/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from '@mui/material/Box';
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// sections for this page
import SectionText from "pages-sections/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "INTERNATIONAL DAY OF THE WORLD'S INDIGENOUS PEOPLES AUSTRALIA - AUGUST 9TH 2020",
  date: "2020-08-08",
  summary: "We are an Australian Digital Marketing Agency based in Melbourne. August 9th marks the annual International day of the World's Indigenous People. In this time of Global pandemic, more than ever, indigenous peoples of the world need particular consideration, especially given they can be more susceptible to novel illnesses such as Covid-19.",
  image: "/img/posts/2020-08-08-IndigenousPeople/international-day-of-the-worlds-indigenous-peoples-header.jpg",
  url: "https://www.tribalism.com.au/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="INTERNATIONAL DAY OF THE WORLD'S INDIGENOUS PEOPLES AUSTRALIA - AUGUST 9TH 2020"
        image="/img/posts/2020-08-08-IndigenousPeople/international-day-of-the-worlds-indigenous-peoples-header.jpg"
        url="https://www.tribalism.com.au/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020"
        type="article"
        description="We are an Australian Digital Marketing Agency based in Melbourne. In this blog we take a look at how some companies get fake reviews written to boost their ratings."

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2020-08-08-IndigenousPeople/international-day-of-the-worlds-indigenous-peoples-header.jpg" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <Box sx={{
                '& h1': {
                  fontSize: {
                    xs: '1.5rem',
                    sm: '2rem',
                    md: '2.5rem',
                    lg: '3rem',
                    xl: '3rem'
                  }
                }
              }}>
                <h1 className={classes.title}>
                  INTERNATIONAL DAY OF THE WORLD'S INDIGENOUS PEOPLES AUSTRALIA - AUGUST 9TH 2020
                </h1>
              </Box>
              <h4 className={classes.subtitle}>
                August 9th marks the annual International day of the World's Indigenous People. In this time of Global pandemic, more than ever indigenous peoples of the world need particular consideration, especially given they can be more susceptible to novel illnesses such as Covid-19. 
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>
      <SectionSimilarStories />
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Creative Tim
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/presentation?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    About us
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://blog.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Blog
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/license?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Licenses
                  </a>
                </ListItem>
              </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , made with{" "}
              <Favorite className={classes.icon} /> by{" "}
              <a
                href="https://www.creative-tim.com?ref=njsmkp-blog-post"
                target="_blank"
              >
                Creative Tim
              </a>{" "}
              for a better web.
            </div>
          </div>
        }
      />
    </div>
  );
}
